import {IServiceFactory} from "../../../../service-factory.interface";
import {MealSsrBase} from "../meal-ssr-base";

//Meniu clatite umplute cu pui si crema de branza
export default class ChmaSsrType extends MealSsrBase {
    constructor(services: IServiceFactory) {
        super('CHMA', services);
    }
}
